export enum InsertSourceInsertDBEnum {
  System = 'system',
  User = 'user'
}
